// extracted by mini-css-extract-plugin
export default {"inner_canvas":"PageOptimizationCycles_inner_canvas__IehSY"};